import { Pagination, Paper, Table } from '@mui/material';
import { StandardButton } from '../buttons/StandardButton';
import { useStyles } from '../styles/TableStyles.styles';
import { SearchTableBody } from './SearchTableBody';
import { SearchTableHeaders } from './SearchTableHeaders';

import type { Coverage } from '@features/redux/slices/designSlice';

interface CoverageTableProps {
    selectCoverage: (coverage: Coverage) => void;
    coverages: Coverage[];
    pageCount: number;
    pageNumber: number;
    selectPage: (page: number) => void;
    loadingCoverage: boolean;
}

const HEADERS = ['Name', 'Coverage ID', ''];

export const CoverageTable = ({
    selectCoverage,
    coverages,
    pageCount,
    pageNumber,
    selectPage,
    loadingCoverage,
}: CoverageTableProps) => {
    const styles = useStyles();

    return (
        <Paper>
            <Table>
                <SearchTableHeaders rows={HEADERS} />

                <SearchTableBody
                    numCols={HEADERS.length}
                    emptyListText={'No Coverages Found'}
                    loading={loadingCoverage}
                    rows={coverages.map((coverage) => {
                        return [
                            { value: coverage.coverageName, isButton: false },
                            { value: coverage.coverageId, isButton: false },
                            {
                                value: (
                                    <StandardButton
                                        key={coverage.coverageName}
                                        text={'Edit'}
                                        onClick={() => selectCoverage(coverage)}
                                    />
                                ),
                                isButton: true,
                            },
                        ];
                    })}
                />
            </Table>

            <div className={styles.pagination}>
                <Pagination
                    color={'primary'}
                    onChange={(_, page) => selectPage(page)}
                    count={pageCount}
                    page={pageNumber}
                />
            </div>
        </Paper>
    );
};
